//midleware
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const AuthenticateAndRolesMiddleware = ({ fallbackPath, module }) => {
      const metUserAndToken = JSON.parse(localStorage.getItem("metUserAndToken"))
      const isAuthenticated = metUserAndToken?.isAuthenticated === true && metUserAndToken?.token;
      if (isAuthenticated) {
            return <Outlet />;
      } else {
            return <Navigate to={fallbackPath} />;
      }
};

export default AuthenticateAndRolesMiddleware;